<template>
    <div class="ecobalyse-ingredients-selects">
        <el-select
            v-for="field in fields"
            :key="field.name"
            v-model="field.value"
            :ref="'select_' + field.name"
            filterable
            remote
            clearable
            :remote-method="(query) => remoteMethod(query, field.name)"
            :loading="field.loading"
            placeholder="Rechercher un ingrédient Ecobalyse..."
            @change="(value) => handleChange(value, field.name)"
            style="width: 100%"
        >
            <el-option
                v-for="item in field.options"
                :key="item.id"
                :label="item.text"
                :value="item.text"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    props: {
        apiUrl: {
            type: String,
            required: true
        },
        initialValues: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            fields: [
                { name: 'ecobalyse_default_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_bio_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_fr_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_desaison_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_horssaison_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_ue_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_horseurope_libelle', value: '', options: [], loading: false },
                { name: 'ecobalyse_origine_inconnue_libelle', value: '', options: [], loading: false }
            ],
            allIngredients: []
        }
    },
    mounted() {
        // Initialiser les valeurs depuis les props
        this.fields.forEach(field => {
            if (this.initialValues[field.name]) {
                field.value = this.initialValues[field.name];
            }
        });

        // Monter chaque select dans son wrapper
        this.$nextTick(() => {
            this.fields.forEach(field => {
                const wrapper = document.getElementById(field.name + '_wrapper');
                if (wrapper) {
                    const selectElement = this.$refs['select_' + field.name][0].$el;
                    wrapper.appendChild(selectElement);
                }
            });

            // Charger les options initiales si valeur présente
            this.fields.forEach(field => {
                if (field.value) {
                    this.loadInitialOptions(field.name);
                }
            });
        });
    },
    methods: {
        async remoteMethod(query, fieldName) {
            const field = this.fields.find(f => f.name === fieldName);
            if (!field) return;

            if (query !== '') {
                field.loading = true;
                try {
                    const response = await fetch(this.apiUrl + '?q=' + encodeURIComponent(query));
                    const data = await response.json();
                    field.options = data.results || [];
                    this.allIngredients = data.results || [];
                } catch (error) {
                    console.error('Erreur lors de la récupération des ingrédients:', error);
                    field.options = [];
                } finally {
                    field.loading = false;
                }
            } else {
                field.options = [];
            }
        },

        handleChange(value, fieldName) {
            // Mettre à jour le champ hidden
            const hiddenField = document.getElementById(fieldName + '_hidden');
            if (hiddenField) {
                hiddenField.value = value || '';
            }

            // Trouver l'ID correspondant et remplir le champ ID
            const ingredient = this.allIngredients.find(item => item.text === value);
            if (ingredient) {
                const idFieldName = fieldName.replace('_libelle', '_id');
                const idField = document.getElementById(idFieldName);
                if (idField) {
                    idField.value = ingredient.id;
                }
            } else if (!value) {
                // Si vide, vider aussi le champ ID
                const idFieldName = fieldName.replace('_libelle', '_id');
                const idField = document.getElementById(idFieldName);
                if (idField) {
                    idField.value = '';
                }
            }
        },

        async loadInitialOptions(fieldName) {
            const field = this.fields.find(f => f.name === fieldName);
            if (!field || !field.value) return;

            try {
                const response = await fetch(this.apiUrl + '?q=' + encodeURIComponent(field.value));
                const data = await response.json();
                field.options = data.results || [];
            } catch (error) {
                console.error('Erreur lors du chargement des options initiales:', error);
            }
        }
    }
}
</script>

<style scoped>
.ecobalyse-ingredients-selects {
    display: contents;
}
</style>
